import { useParams } from 'react-router-dom';

interface TurboLiveRouteParams {
    sportName: string;
    matchId: string;
    marketCategoryId: string;
}

export const useTurboLiveRouteParams = () => {
    return useParams<TurboLiveRouteParams>();
};
